import "./InfrastructurePlan.module.css";
import Header from "@/reusable_sections/Header";
import StrategicOutcomes from "./sections/StrategicOutcomes";
import ServiceAlert from "./sections/ServiceAlert";
import EngineeredForExcellence from "./sections/EngineeredForExcellence";
import Footer from "@/reusable_sections/Footer";
export default function InfrastructurePlanPage() {
  return <div>
      <Header />
      <StrategicOutcomes />
      <ServiceAlert />
      <EngineeredForExcellence />
      <Footer />
    </div>;
}